<template>
  <div>
  <div id="accordionExample" class="accordion shadow">
    <div class="accordion-item">
    <div class="accordion-header">
      <div class="bg-white border-0" style="border-radius: 10px">
        <div class="row align-items-center ps-4 pe-3">
          <div class="col-8 text-start">
            <h5 class="mb-0 fw-bold">{{ $t("Filters") }}</h5>
          </div>
          <div class="col-4 text-end">
            <button class="accordion-button bg-transparent border-0" :class="[{'collapsed': !isFiltersOpen}]" type="button" @click="isFiltersOpen ? hideFilters() : showFilters()">
            </button>
          </div>
        </div>
      </div>
    </div>
      <div id="collapseOne" class="accordion-collapse collapse " :class="[{'show': isFiltersOpen}]" data-bs-parent="#accordionExample">
        <div class="accordion-body">
          <div class="row text-start">
      <div class="col-md-4">
        <div class="form-group has-label">
          <label class="form-label">{{ $t("Status") }}</label>
          <multiselect
              v-model="model.statuses"
              :show-labels="false"
              label="label"
              track-by="key"
              :placeholder="$t('Select status')"
              :options="statuses" :multiple="true"
>
          </multiselect>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group has-label">
          <label class="form-label">{{ $t("Type") }}</label>
          <multiselect
              v-model="model.type"
              :show-labels="false"
              label="label"
              track-by="key"
              :close-on-select="false"
              :placeholder="$t('Select types')"
              :options="types" :multiple="true"
          >
          </multiselect>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group has-label">
          <label class="form-label">{{ $t("Cities") }}</label>
          <multiselect
              v-model="model.cities"
              :show-labels="false"
              label="label"
              track-by="key"
              :close-on-select="false"
              :placeholder="$t('Select cities')"
              :options="cities" :multiple="true"
          >
          </multiselect>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group has-label">
          <label class="form-label">{{ $t("Select date range") }}</label>
          <VueDatePicker
              v-model="model.dates"
              :locale="$store.state.locale"
              format="dd/MM/yyyy"
              :flow="['calendar']"
              :placeholder="$t('Select dates')"
              range
              auto-apply
          ></VueDatePicker>
        </div>
      </div>
    </div>

          <div class="row">
      <div class="col text-end">
        <submit-button
            :alert-message="errorMessage"
            :state="loadingProcess"
            @clicked="getRequests(null, true)"
>
          {{ $t("Search") }}
        </submit-button>
      </div>
    </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <h5 class="mb-0 text-start" :class="type === 'dark' ? 'text-white' : ''">
            {{ $t(title) }}
          </h5>
        </div>
        <div class="col-6 text-end top-0">
<!--          <router-link v-if="$store.state.user.data.status === 'active'" :to="'/requests/multiCreate'" class="btn btn-sm btn-primary mt-1 mb-1 me-2">-->
<!--            <span class="nav-link-text">{{ $t("Create multiple requests") }}</span>-->
<!--          </router-link>-->
          <router-link v-if="$store.state.user !== null && $store.state.user.data.status === 'active'" :to="'/requests/new'" class="btn btn-sm btn-primary mt-1 mb-1">
            <span class="nav-link-text">{{ $t("New Request") }}</span>
          </router-link>
        </div>
<!--        <div class="col text-end">-->
<!--          <base-button tag="a" href="/requests/new" type="primary" size="sm">Add New</base-button>-->
<!--        </div>-->
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush text-start"
        :columns="columns"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="tableData"
        :loading="loading"
        :list-full="listFull"
        :sort-by="sortBy"
        :sort-direction="sortDirection"
        :paginated="true"
        @sort="getRequests"
        @fetch-more="getRequests(null, false)"
      >
        <template #default="row">
          <td>
            <router-link
                :to="'/requests/' + row.item.id"
            >
              <span class="name mb-0 text-sm">{{ row.item.refNumber ?? "No Ref" }}</span>
            </router-link>
</td>
<!--          <td v-if="!hasUser" class="budget">-->
<!--            <span class="name mb-0 text-sm">{{ row.item.clientName }}</span>-->
<!--          </td>-->
          <td class="fw-bold">
            {{ $t(row.item.serviceType ?? "") }}
          </td>
          <td class="fw-bold">
            {{ $t(row.item.city ?? "") }}
          </td>
          <td>
            <div class="status-block">
              <div class="badge m-1 p-1 font-size-sm d-block" :class="getStatusClass(row.item.status)">
                <span class="status">{{ $t(row.item.status) }}</span>
              </div>

              <div v-if="hasReview(row.item.clientReviewId ?? null)" class="badge m-1 p-1 font-size-sm d-block bg-primary">
                <span class="status">{{ $t("Reviewed") }}</span>
              </div>
              <div v-else-if="pendingReview(row.item.mEndDate ?? null,row.item.clientReviewId ?? null, row.item.status ?? null)" class="badge m-1 p-1 font-size-sm d-block bg-warning">
                <span class="status">{{ $t("Pending Review") }}</span>
              </div>
            </div>
<!--            <div class="badge p-1 font-size-sm" :class="getStatusClass(row.item.status)">-->
<!--              <span class="status">{{ $t(row.item.status) }}</span>-->
<!--            </div>-->
          </td>
          <td>
            <div class="fw-bold">
            <span>{{ row.item.cost.totalCost == null ? '€' : row.item.cost.totalCost/100+'€' }}</span>
            </div>
          </td>
          <td>
            <div class="name mb-0 text-md-left">
              <template v-if="row.item.serviceType === 'shift'">
              {{ row.item.mStartDate.format("DD/MM/YYYY") }}  <br>
              {{ row.item.mStartDate.format("HH:mm") + "-"+ row.item.mEndDate.format("HH:mm") }}
              {{ getDuration(row.item.mStartDate, row.item.mEndDate) }}
              </template>
              <template v-else>
                {{ row.item.mStartDate.format("DD/MM/YYYY") }}
              </template>
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center">
              <!--              <span class="completion mr-2">{{ row.item.completion }}%</span>-->
              <!--              <div>-->
              <!--                <base-progress-->
              <!--                  :type="row.item.statusType"-->
              <!--                  :show-percentage="false"-->
              <!--                  class="pt-0"-->
              <!--                  :value="row.item.completion"-->
              <!--                />-->
              <!--              </div>-->
              <div class="name mb-0 text-md-left">{{ row.item.createdAt }}</div>
            </div>
          </td>

          <td class="text-start p-2">
            <router-link
                class="btn bg-gradient-green border-0 me-2 text-white"
                :to="'/requests/' + row.item.id"
            >
              {{ $t("View") }}
            </router-link>

<!--            <base-button-->
<!--              type="success"-->
<!--              class="bg-red border-0"-->
<!--              size="md"-->
<!--              >-->
<!--              {{ $t("Delete") }}-->
<!--</base-button>-->
          </td>
        </template>
      </base-table>
    </div>

    <!--    <div-->
    <!--      class="card-footer d-flex justify-content-end"-->
    <!--      :class="type === 'dark' ? 'bg-transparent' : ''"-->
    <!--    >-->
    <!--      <base-pagination total="30"></base-pagination>-->
    <!--    </div>-->
  </div>
  </div>
</template>
<script>
import {getDuration, getStatusClass} from "@/helpers/common"

export default {
  name: "client-requests-table",
  props: {
    type: {
      type: String,
    },
    title: {
      type: String,
      default: "Requests",
    },
  },
  data() {
    return {
      isFiltersOpen: false,
      cities: [
        {key: "LIMASSOL", label: this.$t("LIMASSOL")},
        {key: "NICOSIA", label: this.$t("NICOSIA")},
        {key: "LARNACA", label: this.$t("LARNACA")},
        {key: "PAPHOS", label: this.$t("PAPHOS")},
        {key: "AMOCHOSTOS", label: this.$t("AMOCHOSTOS")}
      ],
      clientData: {},
      listFull: false,
      loading: true,
      clients: [],
      loadingProcess: "",
      errorMessage: "",
      model: {
        dates: [],
        types: [],
        cities: [],
        statuses: [],
        employees: []
      },
      columns: [
        {
          key:"Ref",
          label:"Ref"
        },
        // {
        //   key:"Client",
        //   label:"Client"
        // },
        {
          key:"Type",
          label:"Type"
        },
        {
          key:"City",
          label:"City"
        },
        {
          key:"status",
          label:"Status",
        },
        {
          key: "cost",
          label: "Cost"
        },
        {
          key: "startDate",
          label: "Shift/Service Date",
          sorting: true
        },
        {
          key: "createdAt",
          label: "Date Created",
          sorting: true
        },
        {
          key: "Actions",
          label: "Actions"
        },
      ],
      types: [
        {key: "shift", label: this.$t("shift")},
        {key: "service", label: this.$t("service")},
      ],
      statuses: [
        {key: "verified", label: this.$t("verified")},
        {key: "purchased", label: this.$t("purchased")},
        {key: "canceled", label: this.$t("canceled")},
        {key: "canceled_refund", label: this.$t("canceled_refund")},
        {key: "canceled_abandoned", label: this.$t("canceled_abandoned")},
        {key: "no_show", label: this.$t("No Show")},
        {key: "finished", label: this.$t("finished")},
      ],
      sortDirection: "desc",
      sortBy: "createdAt",
      tableData: [],
    }
  },
  async mounted() {
    await this.restoreAccordionState()
    if (this.$store.state.user.claims.role === "system") {
      await this.getClients()
    }
    else if (this.$store.state.user.claims.role === "client"){
      this.statuses = this.statuses.filter(s => s.key !== "canceled_refund")
    }
    await this.getRequests()
  },
  created() {
    // Add event listeners for accordion open/close events
    document.addEventListener("shown.bs.collapse", () => { this.saveAccordionState(true)})
    document.addEventListener("hidden.bs.collapse", () => {
      this.saveAccordionState(false)
    })
  },
  beforeUnmount() {
    // Clean up event listeners
    document.removeEventListener("shown.bs.collapse", null)
    document.removeEventListener("hidden.bs.collapse", null)
  },
  methods: {
    saveAccordionState(isOpen) {
      console.log("filtersOpen", isOpen)
      this.isFiltersOpen = isOpen
      localStorage.setItem("filtersOpen", isOpen)
    },
    async restoreAccordionState() {
      const isOpen = localStorage.getItem("filtersOpen")
      console.log("restoreAccordionState??", isOpen)
      this.isFiltersOpen = isOpen === "true"
      if (isOpen === "true") {
        this.showFilters()
      } else {
        console.log("restoreAccordionState running hide")
        this.hideFilters()
      }
    },
    getDuration,
    pendingReview(mEndDate, clientReviewId, status){
      if (this.userRole && this.userRole !== "system"){
        return false
      }
      if (status != null && status !== "FINISHED") {
        return false
      }
      if (mEndDate != null && mEndDate.toDate() > this.today ){
        return false
      }
      if (clientReviewId != null){
        return false
      }
      return true
    },
    hasReview(clientReviewId){
      if (this.userRole && !["system"].includes(this.userRole)){
        return false
      }

      return clientReviewId != null
    },
    async getClient(){
      await this.$store
          .dispatch("fetchClient", this.$store.state.user.claims.clientId)
          .then((data) => {
            console.log("fetchClient ======= ", data)
            this.clientData = data
          })
    },
    getStatusClass,
    async getClients() {
      await this.$store.dispatch("fetchClients").then((data) => {
        this.clients = data
      })
    },
    hideFilters(){
      console.log("lets hideeeeeeeeeee")
      this.saveAccordionState(false)
      // const element = document.getElementById("collapseOne")
      // const filterCollapse = new Collapse(element, {toggle: false})
      // filterCollapse.hide()
    },
    showFilters(){
      this.saveAccordionState(true)
      // const element = document.getElementById("collapseOne")
      // const filterCollapse = new Collapse(element, {toggle: false})
      // filterCollapse.show()
    },
    async getRequests(sorter = null, clear = false) {
      console.log("sorter", sorter)
      console.log("clear", clear)

      this.loading = true
      if (sorter){
        this.sortBy = sorter.field
        this.sortDirection = sorter.order
      }

      if (clear){
        this.tableData = []
        this.lastSnapshot = null
      }

      const filters = {
        types: this.model.types.map(c => c.key) ?? null,
        cities: this.model.cities.map(c => c.key) ?? null,
        statuses: this.model.statuses.map(c => c.key) ?? null,
        employees: this.isEmployee && this.hasUser ? [this.$route.params.id] : this.model.employees.map(c => c.key),
        dates: this.model.dates ?? null,
      }
      let sorting
      if (this.model.dates != null && this.model.dates.length > 0){
        sorting = {
          sortBy: "startDate",
          sortDirection: "desc"
        }
      } else {
        sorting = {
          sortBy: this.sortBy,
          sortDirection: this.sortDirection
        }
      }
      console.log(filters)
      await this.$store.dispatch("fetchClientRequests", {clientId: this.$store.state.user.claims.user_id ?? "",filters: filters, sorting: sorting, lastSnapshot: this.lastSnapshot}).then((result) => {
        console.log("fetchClientRequests", result)
        this.loading = false
        if (result.data === null){
          this.listFull = true
          return
        }

        if (result.lastSnapshot !== null){
          this.lastSnapshot = result.lastSnapshot
        }

        result.data.forEach ( record => {
          // console.log("record", record)
          let index = this.tableData.findIndex(r => r.id === record.id)
          if (index > -1){
            this.tableData[index] = record
          } else {
            this.tableData.push(record)
          }
        })

        this.listFull = result.data === null || result.data.length < 10
      })
    },
  },
}
</script>
<style>
.accordion-button:focus, .accordion-button{
  box-shadow: none!important;
}
</style>
